import { render } from "./OrderInvoiceItemsList.vue?vue&type=template&id=d1859510&scoped=true"
import script from "./OrderInvoiceItemsList.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceItemsList.vue?vue&type=script&lang=js"

import "./OrderInvoiceItemsList.vue?vue&type=style&index=0&id=d1859510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1859510"]])

export default __exports__